export default __webpack_public_path__ + "static/media/Leggings of the Ubah Kan.352b6df5.jpg";